var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardmailimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.34 17.6565C15.6434 18.1209 14.8343 18.3664 14 18.3664C13.1658 18.3664 12.3566 18.1209 11.66 17.6565L0.18643 10.0072C0.122773 9.9648 0.0607578 9.92056 0 9.87506V22.4093C0 23.8463 1.16621 24.9869 2.57759 24.9869H25.4224C26.8594 24.9869 27.9999 23.8206 27.9999 22.4093V9.875C27.9391 9.92061 27.877 9.96496 27.8131 10.0075L16.34 17.6565Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09648 8.64175L12.5701 16.2911C13.0044 16.5807 13.5022 16.7254 13.9999 16.7254C14.4978 16.7254 14.9956 16.5806 15.4299 16.2911L26.9035 8.64175C27.5901 8.18429 28 7.41866 28 6.59234C28 5.1715 26.8441 4.01562 25.4233 4.01562H2.57671C1.15593 4.01568 0 5.17155 0 6.5937C0 7.41866 0.409937 8.18429 1.09648 8.64175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardmailimg);
export default __webpack_public_path__ + "static/media/dashboardmailimg.bb4624c1b5162d85cf1ddbd2cad32f8c.svg";
export { ForwardRef as ReactComponent };